import * as core from '../../../../../../../core'

import { query } from './degree-of-change-by-functional-area.query'

export const RESOURCE = {
  payload: {
    alias: 'degree.of.change.by.functional.area',
    description: 'Chart view of degree of change by functional area',
    name: 'Degree of Change by Functional Area',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
